import { createContext, useContext, useState } from "react";
import { useMakePairs } from "../../hooks/usePairsHook";
import { CFlex } from "../../styles/CommonStyles";
import { loadPersistedData } from "../../utils/persistor";
import PairHeader from "./PairHeader";
import PairTable from "./PairTable";
import Loading from "../common/Loading"
import { PairsBox } from "../../styles/BoxingStyles"


const PairContext = createContext({
    filters: {}, setFilters: () => { }
})

export const usePairContext = () => {
    return useContext(PairContext)
}

const Pairs = () => {

    const starred = loadPersistedData("starred")
    const [filters, setFilters] = useState({
        search: "", pair: null, starred: starred ? starred : []
    })

    const {
        onBoardPairs,
        loading,
        onSortClicked,
        onStarredChange
    } = useMakePairs({ filters, setFilters });


    return (
        <PairContext.Provider value={{ filters, setFilters }}>
            <PairsBox>
                <CFlex>
                    <PairHeader onSortClicked={onSortClicked} />
                    <PairTable pairs={onBoardPairs} onStarredChange={onStarredChange} />
                </CFlex>
                <Loading loading={loading} />
            </PairsBox>
        </PairContext.Provider>
    )
}


export default Pairs;